import { Icon } from '@iconify/react';
import React, { useEffect, useState } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import { useToast } from '../Toast/ToastContext';
import { submitContactForm } from '../../api/contactApi';
// import Cta from '../Cta';

// "company" is a honeypot field - hidden from real visitors via CSS. Bots that
// auto-fill every input on a page will fill this too, which flags them.
const emptyForm = { name: '', email: '', mobile: '', message: '', company: '' };

export default function ContactPage() {
  pageTitle('Contact Us');
  const { showToast } = useToast();
  const [form, setForm] = useState(emptyForm);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function updateField(field, value) {
    setForm((prev) => ({ ...prev, [field]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (form.company) {
      // Honeypot tripped - silently "succeed" without actually submitting.
      setForm(emptyForm);
      return;
    }
    if (!form.name.trim() || !form.email.trim() || !form.mobile.trim()) {
      showToast('Please fill in your name, email, and mobile number.', 'error');
      return;
    }

    setSubmitting(true);
    try {
      await submitContactForm({
        name: form.name,
        email: form.email,
        mobile: form.mobile,
        message: form.message,
      });
      showToast("Thank you! We've received your message.", 'success');
      setForm(emptyForm);
    } catch (err) {
      showToast(err.message || 'Something went wrong. Please try again.', 'error');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
      <PageHeading
        title="Contact Us"
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText="Contact"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading
              title=" We're listening! What do you want to see next?"
              subtitle=""
            />
            <Spacing lg="55" md="30" />
            <ContactInfoWidget withIcon />
            <Spacing lg="0" md="50" />
          </Div>
          <Div className="col-lg-6">
            <form className="row" onSubmit={handleSubmit}>
              {/* Honeypot field - kept out of tab order and visually hidden */}
              <input
                type="text"
                name="company"
                value={form.company}
                onChange={(e) => updateField('company', e.target.value)}
                style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px' }}
                tabIndex="-1"
                autoComplete="off"
                aria-hidden="true"
              />

              <Div className="col-sm-6">
                <label className="cs-primary_color">Full Name*</label>
                <input
                  type="text"
                  className="cs-form_field"
                  value={form.name}
                  onChange={(e) => updateField('name', e.target.value)}
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Email*</label>
                <input
                  type="email"
                  className="cs-form_field"
                  value={form.email}
                  onChange={(e) => updateField('email', e.target.value)}
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Mobile*</label>
                <input
                  type="text"
                  className="cs-form_field"
                  value={form.mobile}
                  onChange={(e) => updateField('mobile', e.target.value)}
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-12">
                <label className="cs-primary_color">Suggestions </label>
                <textarea
                  cols="30"
                  rows="7"
                  className="cs-form_field"
                  value={form.message}
                  onChange={(e) => updateField('message', e.target.value)}
                ></textarea>
                <Spacing lg="25" md="25" />
              </Div>
              <Div className="col-sm-12">
                <button className="cs-btn cs-style1" type="submit" disabled={submitting}>
                  <span>{submitting ? 'Sending...' : 'Send Message'}</span>
                  <Icon icon="bi:arrow-right" />
                </button>
              </Div>
            </form>
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="80" />
      <Div className="cs-google_map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3776.3675669677937!2d82.6978572109801!3d18.82631755968937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3af1e5b39fef67%3A0xb66b2190dffc2614!2sMEGHRAJ%20CINEMAZ!5e0!3m2!1sen!2sin!4v1747408621335!5m2!1sen!2sin"
          allowFullScreen
          title="Google Map"
        />
      </Div>
      <Spacing lg="50" md="40" />
      {/* Start CTA Section */}
      {/* <Div className="container">
        <Cta
          title="Let's disscuse make <br />something <i>cool</i> together"
          btnText="Apply For Meeting"
          btnLink="/contact"
          bgSrc="/images/cta_bg_3.jpeg"
        />
      </Div> */}
      {/* End CTA Section */}
    </>
  );
}